import useWindowSize from "@hooks/useWindowSize";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import styles from "./DetailTableComponent.module.css";

const DetailTableComponent = ({ columns, rows }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const window = useWindowSize();
  const responsiveFontSize = window?.width > 600 ? "1.5rem" : "1rem";

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <div className={styles.Wrapper}>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 20,
                }}
              >
                {columns.map((column, index) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: window?.width > 600 ? 170 : 0,
                      fontSize: responsiveFontSize,
                      position: index === 0 ? "sticky" : "relative",
                      left: 0,
                      zIndex: index === 0 ? 2 : 0,
                      padding: window?.width > 600 ? "16px" : "7px 16px",
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={`${row.code}${index}`}
                    >
                      {columns.map((column, index) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              position: index === 0 ? "sticky" : "relative",
                              left: 0,
                              zIndex: index === 0 ? 2 : 0,
                              background: "#fff",
                              fontSize: responsiveFontSize,
                              padding:
                                window?.width > 600 ? "16px" : "7px 16px",
                            }}
                          >
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            fontSize: responsiveFontSize,
            "& .MuiTablePagination-selectLabel": {
              fontSize: responsiveFontSize,
            },
            "& .MuiTablePagination-displayedRows": {
              fontSize: responsiveFontSize,
            },
          }}
        />
      </Paper>
    </div>
  );
};

export default DetailTableComponent;
